import { Skeleton, TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  rsTableCellLoader: {
    "&>span": {
      transform: "scale(1)",
    },
  },
}));

const TableCellLoader = (props) => {
  const { rows = 28, cells = 4 } = props;

  const classes = useStyle();

  return (
    <>
      {[...Array(rows)]?.map((item) => {
        return (
          <TableRow>
            {[...Array(cells)]?.map((cell) => {
              return (
                <TableCell className={classes.rsTableCellLoader}>
                  <Skeleton />
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </>
  );
};

export default TableCellLoader;
